import { h } from 'preact';

import { connect } from 'redux-zero/preact';
import { $lang } from '../plugins/helper';
import actions from '../store/actions';

const Modal = (props) => {
    const { handleModal , startOver} = props;

    return (
        <div className="et-modal"
            style="background: #263175c9;">
            <div className="et-modal-body md:et-max-w-sm">
                <div className="modal-content et-pb-4 et-pt-10 et-text-left et-px-10">

                    <div className="et-pb-3">
                        <p className="et-text-2xl et-text-center">{$lang('start_over_question')}</p>
                    </div>

                    <div className="et-flex et-justify-between et-pt-4">
                        <button onClick={() => handleModal(false)} className="neo-btn neo-btn--primary et-rounded-full et-px-10 et-py-3 et-font-light et-capitalize et-shadow-lg">{$lang('button.cancel')}</button>
                        <button onClick={() => startOver()} className="neo-btn et-rounded-full et-px-12 et-py-3 et-font-light et-capitalize et-border-gray-300 et-shadow-lg">{$lang('button.yes')}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default connect(null, actions)(Modal)